<template>
  <div>
    <div class="search-wrapper">
      <Form inline label-position="left" :label-width="50" :label-colon="true">
        <FormItem label="品牌">
          <Select v-model="brandId" clearable>
            <Option v-for="item in brands" :key="item.id" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="车型">
          <Input v-model="device" type="text" placeholder="车型" />
        </FormItem>
        <FormItem class="search-button">
          <Button type="primary" @click="searh">查询</Button>
        </FormItem>
      </Form>

      <Button type="primary" @click="add">新增</Button>
    </div>

    <div class="container-wrapper">
      <Table border :columns="columns" :data="data">
        <template slot-scope="{ row }" slot="image">
          <img class="image-item" :src="row.image" alt="">
        </template>
        <template slot-scope="{ row }" slot="description">
          <Tooltip max-width="800" :content="row.description" :transfer="true">
            <span>{{ row.description.substring(0, 20) }}...</span>
          </Tooltip>
        </template>
        <template slot="operator" slot-scope="{ row }">
          <ButtonGroup>
            <Button @click="edit(row.id)" type="primary" size="small">编辑</Button>
            <Button type="error" size="small" @click="removeCrane(row.id)">删除</Button>
          </ButtonGroup>
        </template>
      </Table>
      <div class="pagination-container">
        <Page :total="paginator.total" :page-size="paginator.size" @on-change="changePage" :current.sync="paginator.page" />
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

const columns = [
  {title: '车型', key: 'name', width: 160},
  {title: '品牌', key: 'brand', width: 120},
  {title: '图片', key: 'image', slot: 'image'},
  {title: '吊车介绍', key: 'description', slot: 'description'},
  {title: '操作', slot: 'operator', width: 240}
];

export default {
  data() {
    return {
      columns,
      data: [],
      paginator: {},
      brands: [],
      brandId: '',
      device: ''
    }
  },
  methods: {
    edit(id) {
      this.$router.push({name: 'car.edit', params: {id}})
    },
    add() {
      this.$router.push({name: 'car.add'})
    },
    setting() {
      api.get(api.url('setting')).then(res => {
        this.brands = res.brands;
      }).catch(err => {
        this.$Message.error(err);
      });
    },
    init() {
      api.get(api.url('cranes'), this.getParams()).then(res => {
        this.data = res.items;
        this.paginator = res.paginator;
      }).catch(err => {
        this.$Message.error(err);
      })
    },
    getParams() {
      return {
        page: this.$route.query.page || 1,
        size: 15,
        brandId: this.$route.query.brandId || '',
        device: this.$route.query.device || ''
      }
    },
    changePage(page) {
      this.$router.push({query: {page, brandId: this.brandId, device: this.device}})
    },
    searh() {
      this.$router.push({query: {brandId: this.brandId, device: this.device, page: 1}})
    },
    removeCrane(id) {
      api.delete(api.url('craneUpdate', id)).then(() => {
        this.$Message.success('删除成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  mounted() {
    this.setting();
    this.init();
  },
  watch: {
    '$route'() {
      this.init();
    }
  }
}
</script>

<style>
  .search-wrapper { display: flex; justify-content: space-between; }

  .image-item { width: 90px; max-height: 60px; margin-top: 6px; }
  .search-button .ivu-form-item-content { margin-left: 0 !important; }
  .pagination-container { margin: 24px 0; float: right; }
</style>
